import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material';
import { AutoLogOutDialogComponent } from '../components/auto-log-out-dialog.component';
import { LogoutAction, USER_IDENTITY_UPDATED } from '../../security/store/actions/index';
import { SessionExtendedAction } from '../../security/store/actions/SessionExtendedAction';
import { timer } from 'rxjs/observable/timer';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { ActivityAction } from './action/ActivityAction';
import { AppConfigurationService } from '../services/AppConfigurationService';

export const LoginRedirectUrlKey = 'login_redirect_url';
@Injectable()
export class ApplicationEffects {
  
  APPLICATION_TIMEOUT_TIME = 1000 * 60 * 10;
  blockKeepAlive: boolean = false;
  readonly loginRedirectUrlKey = LoginRedirectUrlKey;

  @Effect()
  extendApplicationTimeout$ = this.actions$
    .filter((a) => a.type !== USER_IDENTITY_UPDATED )
    .switchMap(() => timer(this.APPLICATION_TIMEOUT_TIME))
    .skipWhile(() => !this.currentUserService.userContext.isAuthenticated)
    .concatMap(() => {
      this.blockKeepAlive = true;
      let dialogRef = this.dialog.open(AutoLogOutDialogComponent, {
        panelClass: 'customized-dialog',
        disableClose: true
      });

      return dialogRef.afterClosed()
        .timeout(70000);
    })
    .catch(() => Observable.of(false))
    .map(result => {
      if (!result) {
        return new LogoutAction();
      }
      this.blockKeepAlive = false;
      return new SessionExtendedAction();
    });

  constructor(private actions$: Actions,
    public dialog: MatDialog,
    public currentUserService: CurrentUserService,
    private store: Store<any>,
    private appConfigurationService: AppConfigurationService) {
    if (appConfigurationService.configuration.applicationInactivityTimeoutMinutes) {
      this.APPLICATION_TIMEOUT_TIME = 1000 * 60 * appConfigurationService.configuration.applicationInactivityTimeoutMinutes;
    }
    var postKeepAlive: boolean = false;
    window.addEventListener("mousemove",
      () => {
        postKeepAlive = true;
        this.store.dispatch(new ActivityAction());
      });
    window.addEventListener("resize",
      () => {
        postKeepAlive = true;
        this.store.dispatch(new ActivityAction());
      });
    document.addEventListener("keydown",
      () => {
        postKeepAlive = true;
        this.store.dispatch(new ActivityAction());
      });
    window.addEventListener("scroll",
      () => {
        postKeepAlive = true;
        this.store.dispatch(new ActivityAction());
      });
    window.addEventListener("mousewheel",
      () => {
        postKeepAlive = true;
        this.store.dispatch(new ActivityAction());
      });
    window.addEventListener("DOMMouseScroll",
      () => {
        postKeepAlive = true;
        this.store.dispatch(new ActivityAction());
      });
    window.addEventListener("storage", (event) => {
      if(event.storageArea == localStorage){
        let token = localStorage.getItem(this.loginRedirectUrlKey);
        if(token == undefined){
          this.store.dispatch(new LogoutAction());
          sessionStorage.clear();
        }
      }
    })
    var iframe;
    function postActivity(timestamp: Date) {
      if (!iframe || !iframe.contentWindow) return;
      var message = { "activityTimestamp": timestamp };
      iframe.contentWindow.postMessage(message, "*");
    }
    var accountSessionStem = appConfigurationService.configuration.securityServer.browserUserAccountSessionIframeSrcStem;
    if (accountSessionStem) {
      iframe = window.document.createElement('iframe');
      iframe.onload = () => { postActivity(new Date()); };
      iframe.style.display = 'none';
      iframe.src = appConfigurationService.configuration.securityServer.baseEndpoint + accountSessionStem;
      window.document.body.appendChild(iframe);
      var lastActivityTimestamp: Date;
      window.addEventListener("message",
        event => {
          if (!event.data.browserUserAccountSession) {
            return;
          }
          if (event.data.browserUserAccountSession.isAlive === false) {
            this.store.dispatch(new LogoutAction());
          } else if (event.data.browserUserAccountSession.activityTimestamp) {
            var activityTimestamp: Date = new Date(event.data.browserUserAccountSession.activityTimestamp);
            if (lastActivityTimestamp) {
              if (activityTimestamp <= lastActivityTimestamp) {
                return;
              }
            }
            lastActivityTimestamp = activityTimestamp;
            this.store.dispatch(new ActivityAction());
          }
        },
        false);
      setInterval(() => {
        if (!postKeepAlive || this.blockKeepAlive || !this.currentUserService.userContext.isAuthenticated) {
          return;
        }
        postKeepAlive = false;
        postActivity(new Date());
      },
        appConfigurationService.configuration.securityServer.browserUserAccountSessionKeepAliveIntervalMilliseconds);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/store/ApplicationEffects.ts